import { useCallback } from "react";

import { usePatchReportColumn } from "@/queries";
import { ReportColumn } from "@/types/evaluate";
import { useAuth } from "@/context/auth-context";

interface UseColumnMovementProps {
  reportId: number;
}

export const useColumnMovement = ({ reportId }: UseColumnMovementProps) => {
  const userToken = useAuth()?.userToken || "";
  const { mutate: patchColumn } = usePatchReportColumn(userToken, reportId);

  const handleMoveColumn = useCallback(
    (column: ReportColumn, newPosition: number) => {
      if (column.id && column.position !== undefined) {
        const updatedColumn = { ...column, position: newPosition };
        patchColumn(updatedColumn);
      }
    },
    [patchColumn],
  );

  return { handleMoveColumn };
};
